export const SIGN_UP_SECTIONS = {
  profile: {
    title: 'ssp.information.profile',
    id: 'profile',
  },
  locations: {
    title: 'ssp.information.locations',
    id: 'locations',
  },
  subscriptions: {
    title: 'ssp.main.title.subscriptions',
    id: 'subscriptions',
  },
  information: {
    title: 'ssp.information.information',
    id: 'information',
  },
  review: {
    title: 'ssp.information.review',
    id: 'review',
  },
};

export const SECURITY_QUESTION_OPTIONS = {
  QUESTION_ELEVEN: 'question_eleven',
  QUESTION_ONE: 'question_one',
  QUESTION_TWO: 'question_two',
  QUESTION_THREE: 'question_three',
  QUESTION_FOUR: 'question_four',
  QUESTION_FIVE: 'question_five',
  QUESTION_SIX: 'question_six',
  QUESTION_SEVEN: 'question_seven',
  QUESTION_EIGHT: 'question_eight',
  QUESTION_NINE: 'question_nine',
  QUESTION_TEN: 'question_ten',
};

export const USER_STATUS = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  FEDRAMP: 'fedRamp',
};
export const DEFAULT_MAP_CENTER = {
  lat: 37.09024,
  lng: -95.712891,
};
export const paramMap = new Map([
  ['new', { paramType: 'signUp', defaultContent: 'ssp.help.default.signUp' }],
  ['new/account/subscriptions', { paramType: 'alerts', defaultContent: 'ssp.help.default.alerts' }],
  ['new/account/profile', { paramType: 'profile', defaultContent: 'ssp.help.default.profile' }],
  ['new/account/mylocation',
    { paramType: 'locations', defaultContent: 'ssp.help.default.locations' }],
  ['new/account/additionalInformation',
    { paramType: 'information', defaultContent: 'ssp.help.default.information' }],
  ['new/account/review',
    { paramType: 'review', defaultContent: 'ssp.help.default.review' }]
]);
